import {AIContent} from "./aiContent.model";
import {AITranscript} from "./aiTranscript.model";
import {AIDocumentPage} from "./aiDocumentPage";

/**
 * Type of a subchapter — decided by the LLM at plan generation time.
 * Drives downstream rendering (slides vs. quiz vs. video explainer sequence).
 * SLIDE is the retrocompat default when legacy JSON omits the field.
 */
export enum SubChapterType {
    SLIDE = 'SLIDE',           // avatar + illustrations (current default)
    EXPLAINER = 'EXPLAINER',   // auto-generated stylised videos (stickman/whiteboard/etc.)
    QUIZ = 'QUIZ'              // quiz questions
}

export class AISubChapter {
    title: string;
    number: number;
    id?: number;
    content: AIContent;
    transcript: AITranscript;
    documentPages: AIDocumentPage[];
    subjects: string[];
    chapterID:string;
    autoTranscriptStatus: AutoTranscriptStatus;
    type: SubChapterType;
    // Resolved hidden prompt for this subchapter — combines the per-subchapter
    // context (title, subjects, training-module JSON), the visual template's
    // hiddenPrompt (for EXPLAINER), and the type-specific suffix. Persisted so
    // "Continue via AI" reproduces the same generation instructions even if the
    // per-type config evolves. Never shown in any UI editor.
    hiddenPromptGeneration?: string;

    constructor() {
        this.title = "";
        this.number = 0;
        this.content = new AIContent();
        this.transcript = new AITranscript();
        this.documentPages=[];
      this.autoTranscriptStatus = AutoTranscriptStatus.NA;
      this.chapterID=""
      this.subjects=[]
      this.type = SubChapterType.SLIDE;
    }
}

export enum AutoTranscriptStatus {
  NONE='NONE',
  WAITING='WAITING',
  DONE='DONE',
  ERROR='ERROR',
  NA='NA'
}
